import { StoreApi } from 'zustand';
import createContext from 'zustand/context';
import { FeedbackSummaryStateWithRedux } from './types';

export const FeedbackSummaryStoreContext =
  createContext<StoreApi<FeedbackSummaryStateWithRedux>>();
